module.exports = __webpack_public_path__ + "static/img/IPimg3.91ec17b8.png";